import { useState } from "react";
import icon from "../../../../img/material.png";
export function MaterialPopup(props) {
  const searchParams = new URLSearchParams(document.location.search);
  const [prevMaterial, setPrevMaterial] = useState(
    searchParams.get("plateMaterial") ?? "Regular"
  );
  const updateMerial = (item) => {
    if (
      prevMaterial === "3D Domed" ||
      prevMaterial === "4D Raised" ||
      prevMaterial === "5D Raised"
    ) {
      props.updateChoosedOptions({
        fontStyle: "CharlesWright Bold",
        fontPrice: 0,
      });
    }
    props.updateChoosedOptions({
      plateMaterial: item.type,
      materialPrice: item.price,
    });
    if (item.type === "3D Domed") {
      props.plateBuilder["font-family"].map((item) => {
        if (item.font === "laser3d webfont") {
          props.updateChoosedOptions({
            fontStyle: item.font,
            fontPrice: item.price,
          });
        }
      });
    }
    if (item.type === "4D Raised") {
      props.plateBuilder["font-family"].map((item) => {
        if (item.font === "Dome4D") {
          props.updateChoosedOptions({
            fontStyle: item.font,
            fontPrice: item.price,
          });
        }
      });
    }
    if (item.type === "5D Raised") {
      props.plateBuilder["font-family"].map((item) => {
        if (item.font === "Dome5D") {
          props.updateChoosedOptions({
            fontStyle: item.font,
            fontPrice: item.price,
          });
        }
      });
    }
    if (
      item.type === "Silver" ||
      item.type === "Black" ||
      item.type === "Silver Mirror" ||
      item.type === "Pressed Metal" ||
      item.type === "Pressed Metal Black"
    ) {
      props.updateChoosedOptions({
        hasCustomBadgeLeft: "false",
        hasCustomBadgeRight: "false",
        customBadgeLeft: "null",
        customBadgeRight: "null",
        customBadgeImageLeft: "null",
        customBadgeImageRight: "null",
        customBadgeTextLeft: "null",
        customBadgeTextRight: "null",
        customBadgeTextColorLeft: "null",
        customBadgeTextColorRight: "null",
        customBadgeRotationLeft: "false",
        customBadgeRotationRight: "false",
        badgeRight: "null",
        badgeLeft: "null",
        sloganName: "",
        showBSAU: "false",
        badgeLeftName: "null",
        badgeRightName: "null",
      });
    }
    if (item.design === "false" || item.design === false) {
      props.updateChoosedOptions({ designRequired: "hide" });
    } else if (props.choosedOptions.designRequired == "hide") {
      props.updateChoosedOptions({ designRequired: "false" });
    }
    setPrevMaterial(item.type);
  };
  useState(() => {
    if (props.choosedOptions.plateMaterial !== "null") {
      props.plateBuilder["plate-type"].map((item) => {
        if (item.type.includes(props.choosedOptions.plateMaterial)) {
          if (item.design === "false" || item.design === false) {
            props.updateChoosedOptions({ designRequired: "hide" });
          }
        }
      });
    } else {
      props.plateBuilder["plate-type"].map((item) => {
        if (item.type.includes('Regular')) {
          if (item.design === "false" || item.design === false) {
            props.updateChoosedOptions({ designRequired: "hide" });
          }
        }
      });
    }
  }, [props.choosedOptions.categoryPlate]);
  return (
    <div className="option-popup__wrapper">
      <div
        className="option-popup__close"
        onClick={() => props.closePopup(null)}
      ></div>
      <div className="option-popup__title flex items-center">
        <figure className="option-popup__icon">
          <img src={icon} alt="size icon" />
        </figure>
        <h4>Plate Material</h4>
      </div>
      <p>Select your plate size from the options below</p>
      <div className="option-popup__options grid">
        {props.plateBuilder["plate-type"].map((item) => {
          if (
            item.category.includes(props.choosedOptions.categoryPlate.includes("show") ? "show" : "standard") &&
            item.typeOfTransport.includes(props.choosedOptions.typeOfTransport)
          ) {
            return (
              <div
                className={
                  item.type === props.choosedOptions.plateMaterial
                    ? "option-popup__option--active option-popup__option"
                    : " option-popup__option"
                }
                onClick={() => updateMerial(item)}
              >
                <div className="option-popup__option-icon">
                  <img
                    width="70"
                    height="70"
                    src={item.image}
                    alt="font placeholder"
                  />
                </div>
                <p>{item.type}</p>
                <div className="option-popup__tooltip">{item.description}</div>
              </div>
            );
          }
        })}
      </div>
      <div className="option-popup__btn flex justify-center">
        <div className="btn" onClick={() => props.closePopup(null)}>
          CONTINUE
        </div>
      </div>

      {props.choosedOptions.categoryPlate.includes("standard") && (
        <div className="option-popup__switch-show">
          <h6>Don’t see the material you’re looking for?</h6>
          <p>
            The materials shown above are ‘Road compliant’ Standard materials,
            but we can produce your number plates in a wide variety of different
            materials and finishes as part of our Show Plates range.
          </p>

          <div className="option-popup__btn flex justify-center">
            <div
              className=" btn btn--with-border"
              onClick={() =>
                props.updateChoosedOptions({
                  categoryPlate: "show",
                  sloganName: "",
                  showBSAU: "false",
                })
              }
            >
              SWITCH TO SHOW PLATES
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
